module.exports = __webpack_public_path__ + "media/images/icon_work_article01-5dc21a5c6d4924a2ab8c8ca5e96a68ae.svg";